export default [
  {
    path: '/detail',
    name: 'demo-detail',
    component: () => import('@/views/admin/demo/DemoDetail.vue'),
    meta: { layout: 'empty' },
  },
  {
    path: '/third',
    name: 'demo-third',
    component: () => import('@/views/admin/demo/DemoThird.vue'),
    meta: { layout: 'empty' },
  },
  {
    path: '/admin/demo/list-basic',
    name: 'M9921',
    component: () => import('@/views/admin/demo/ListBasic.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/demo/list-fix-header',
    name: 'M9922',
    component: () => import('@/views/admin/demo/ListFixHeader.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/demo/custom-svg-icons',
    name: 'M9924',
    component: () => import('@/views/admin/demo/CustomSvgIcons.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/demo/button-list',
    name: 'M9925',
    component: () => import('@/views/admin/demo/ButtonList.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/demo/feedback-demo',
    name: 'M9926',
    component: () => import('@/views/admin/demo/FeedbackDemo.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/demo/custom-demo-page',
    name: 'admin-demo-custom-demo-page',
    component: () => import('@/views/admin/demo/CustomDemoPage.vue'),
    meta: { layout: 'admin', title: '我是自定义页面标题' },
  },
];
